import axios from 'axios';
import { mbcbase } from '@/config';

export default {
  async postAccountInfo(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v2/account-info`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postAccountInfo20(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v3/account-info`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async putPassword(body) {
    try {
      const res = await axios.post(`${mbcbase}put/api/v1/password`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postCustomProfileSettingCustomProfileId(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/custom-profile-setting/custom-profile-id`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getMemberAccount(params, headers) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v1/member-account`, {}, { params, headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMemberAccount(body, headers) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/member-account`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async putMemberAccount(body) {
    try {
      const res = await axios.post(`${mbcbase}put/api/v1/member-account`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postCustomerdataquery(body, headers) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/customerdataquery`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async putCustomerdataupdate(body, headers) {
    try {
      // 2020.10.29 修改為v2
      // 因修改密碼邏輯不正確 https://3maeaj.axshare.com/#g=1&p=api____-_put__customerdataupdate_1
      const res = await axios.post(`${mbcbase}put/api/v2/customerdataupdate`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postCustomerDataAdd(body, headers) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/CustomerDataAdd`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getAccountVerifier(params) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v1/account-verifier`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postCustomerDataBind(body, headers) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/customerdatabind`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getUriBindServiceV2(params) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v2/uri-bind-service`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  },
  async postJoinMemberGift(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/join-member-gift`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postProspectiveCustomerRelease(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/member/prospective-customer/release`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getProspectiveCustomerRichmenuTag(params) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v1/member/prospectiveCustomer/richmenutag`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getAccountMemberInfo(params) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v1/account/member-info`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postIdentifySourceAvailability(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/identifySource/availability`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getIdentifySourceExistence(params) {
    try {
      const res = await axios.post(`${mbcbase}get/api/v1/identifySource/existence`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async putIdentifySource(body) {
    try {
      const res = await axios.post(`${mbcbase}put/api/v1/identifySource`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMobileVerifyCodeAccount(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/mobile-verify-code/account`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMobileVerifyCodeVerifierAccount(body) {
    try {
      const res = await axios.post(`${mbcbase}post/api/v1/mobile-verifycode-verifier/account`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
